import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useLayout } from '../../../../providers/Layout.provider';
import { useBank } from '../../../../providers/Bank.provider';
import styles from './BankTypeContainer.module.scss';

const { Box, Button } = vp;

type AccountTypeProps = {
  hasNoOnlineOption: boolean;
};

type FC = FunctionComponent<AccountTypeProps>;

const AccountTypeContainer: FC = (props: AccountTypeProps) => {
  const { hasNoOnlineOption } = props;
  const { color } = useLayout();
  const { FinancialInstitution, AccountType, setAccountType } = useBank();
  const { t } = useTranslation('translations', { keyPrefix: 'BankConnection' });

  return (
    <Box flx="col">
      <h3 className={styles.accountType}>{`${t('accountType')}`}</h3>
      <div className={styles.typeButtonContainer}>
        <Button
          id="personal-account"
          label={`${t('personalButton')}`}
          type="submit"
          color={vp.getLuminance(color) > 0.5 ? 'primary' : 'none-light'}
          background={AccountType === 'personal' ? color : 'none'}
          textColor={AccountType === 'personal' ? vp.getContrastColor(color) : '#747474'}
          width="100%"
          height="46px"
          round
          bold
          noShadow
          fontUnit="px"
          textSize={15}
          fontWeight={AccountType === 'personal' ? 700 : 400}
          icon="check"
          iconLocation="left"
          isIconVisible={AccountType === 'personal'}
          isDisabled={FinancialInstitution?.FinancialInstitutionID === '' && !hasNoOnlineOption}
          onClick={() => {
            setAccountType('personal');
          }}
        />
        <Button
          id="bussiness-account"
          label={`${t('businessButton')}`}
          type="submit"
          color={vp.getLuminance(color) > 0.5 ? 'primary' : 'none-light'}
          background={AccountType === 'business' ? color : 'none'}
          textColor={AccountType === 'business' ? vp.getContrastColor(color) : '#747474'}
          width="100%"
          height="46px"
          round
          bold
          noShadow
          fontUnit="px"
          textSize={15}
          fontWeight={AccountType === 'business' ? 700 : 400}
          icon="check"
          iconLocation="left"
          isIconVisible={AccountType === 'business'}
          isDisabled={FinancialInstitution?.FinancialInstitutionID === '' && !hasNoOnlineOption}
          onClick={() => {
            setAccountType('business');
          }}
        />
      </div>
    </Box>
  );
};

export default AccountTypeContainer;
